<div class="flex">
  <i
    class="pi filter-clear-icon"
    [class.pi-filter]="!isActive"
    [class.pi-filter-fill]="isActive"
    (click)="onIconClick($event); $event.stopPropagation()"
  ></i>
  <span class="filter-repr">{{ filterRepr$ | async }}</span>
</div>

<ng-template #formTemplate>
  <form [formGroup]="filterForm">
    <div class="flex flex-column w-25rem row-gap-3">
      <div class="flex justify-content-between">
        <p-dropdown
          [style]="{ width: '120px' }"
          [options]="dateFilterOptions"
          formControlName="matchMode"
          (onChange)="updateActiveStatus()"
        ></p-dropdown>
        <i class="pi pi-filter-slash filter-clear-icon" (click)="resetFilter()"></i>
      </div>

      <!-- single date selection-->
      <ng-container *ngIf="filterForm.value.matchMode !== 'BETWEEN'; else dateRangeSelection">
        <p-calendar
          #dateInput
          class="p-calendar-hide-datepicker"
          [ngModel]="filterForm.value.dateSingle"
          [ngModelOptions]="{ standalone: true }"
          (input)="onDateInput(dateInput.value, false)"
          (keydown.enter)="onKeydownEnter()"
        ></p-calendar>
        <p-calendar
          [inline]="true"
          formControlName="dateSingle"
          [yearNavigator]="true"
          [monthNavigator]="true"
          yearRange="1900:2099"
          (onSelect)="onDateSelect(false)"
        ></p-calendar>
      </ng-container>

      <!-- date range selection -->
      <ng-template #dateRangeSelection>
        <p-calendar
          #dateInput
          class="p-calendar-hide-datepicker"
          [ngModel]="filterForm.value.dateRange"
          [ngModelOptions]="{ standalone: true }"
          (input)="onDateInput(dateInput.value, true)"
          (keydown.enter)="onKeydownEnter()"
          selectionMode="range"
        ></p-calendar>
        <p-calendar
          [inline]="true"
          formControlName="dateRange"
          [yearNavigator]="true"
          [monthNavigator]="true"
          yearRange="1900:2099"
          (onSelect)="onDateSelect(true)"
          selectionMode="range"
        ></p-calendar>
      </ng-template>
    </div>
  </form>
</ng-template>

<p-overlayPanel #op appendTo="body">
  <ng-template pTemplate>
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </ng-template>
</p-overlayPanel>

<p-dialog [header]="header" [(visible)]="showDialog" modal="true" appendTo="body">
  <div style="width: 400px">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </div>
</p-dialog>
